import * as Action from "@actions/index";
import * as Model from "@models/index";
import { useDispatch } from "@helpers/Store";

export default class Direction {
  public static async load() {
    useDispatch(Action.Stand.Direction.setStatus("loading"));
    try {
      const response = await new Model.Stand().directions();
      useDispatch(Action.Stand.Direction.setList(response.data));
      useDispatch(Action.Stand.Direction.setStatus("loaded"));
      return response.data;
    } catch (Exception) {}
  }
}
